export const APPLY_DATA = 'apply_data';
export const BACKUP_INSTANCE_CREATED = 'backup_instance_created';
export const CHANGE_STEP = 'change_step';
export const DEMO_IMPORTANT_RECORDS_COUNT = 'demo_important_records_count';
export const HIDE_PAGE_MESSAGE = 'hide_page_message';
export const HIDE_STEP_LOADING = 'hide_step_loading';
export const MAPPING_DEFAULT_VALUE = 'mapping_default_value';
export const MAPPING_HIDE_DEFAULT_VALUE = 'mapping_hide_default_value';
export const MAPPING_HIDE_RULE_FILTERS = 'mapping_hide_rule_filters';
export const MAPPING_HIDE_RULE_OPTIONS = 'mapping_hide_rule_options';
export const MAPPING_HIDE_SELECT_VALUE = 'mapping_hide_select_value';
export const MAPPING_RULE_FILTERS = 'mapping_rule_filters';
export const MAPPING_RULE_OPTIONS = 'mapping_rule_options';
export const MAPPING_SELECT_VALUE = 'mapping_select_value';
export const MAPPING_SHOW_DEFAULT_VALUE = 'mapping_show_default_value';
export const MAPPING_SHOW_RULE_FILTERS = 'mapping_show_rule_filters';
export const MAPPING_SHOW_RULE_OPTIONS = 'mapping_show_rule_options';
export const MAPPING_SHOW_SELECT_VALUE = 'mapping_show_select_value';
export const PLATFORM_DATA_SET = 'platform_data_set';
export const SHOW_PAGE_MESSAGE = 'show_page_message';
export const SHOW_STEP_LOADING = 'show_step_loading';
export const STEP_DATA_LOADED = 'step_data_loaded';
export const SUBMIT_STEP = 'submit_step';
export const SHOW_AUTHORIZATION = 'show_authorization';

export const AI = {
    SESSION: {
        INIT: 'ai.session.init',
        CLOSE: 'ai.session.close',
    },
} as const;

export const MAPPING = {
    SAVE: 'mapping.save',
    IMPORT: 'mapping.import',
    MESSAGES: 'mapping.messages',
    NOTES: {
        SHOW: 'mapping.notes.show',
        ADD: 'mapping.notes.add',
        VIEW: 'mapping.notes.view',
        LINK: 'mapping.notes.link',
        UPDATE: 'mapping.notes.update',
    },
} as const;

export const APP = {
    UPDATE: 'app.update',
    MODULES: 'app.modules',
    MAINTENANCE: 'maintenance',
} as const;

export const MIGRATION = {
    ENTITIES: {
        REFRESH: 'app.migration.entities.refresh',
    },
} as const;

export const MANAGER = {
    CRM: {
        VIEW_ENTITY_GRAPH: 'crm.view_entity_graph',
    },
    MIGRATION: {
        EDIT_ENTITY_PRIORITY: 'migration.edit_entity_priority',
        ENTITY: {
            EDIT_FILTER: 'migration.entity.edit_filter',
            EDIT_RELATION_PRIORITY: 'migration.entity.edit_relation_priority',
        },
        INSTANCE: {
            SETTINGS: 'migration.instance.settings',
        },
        SCHEDULE: {
            SETTINGS: 'migration.schedule.settings',
        },
    },
} as const;

export const USER = {
    GUID: 'user.guid',
    REDIRECT: 'user.redirect',
    MESSAGE: 'user.message',
} as const;
